import React from 'react';
import { Box, Container, ContainerProps } from '@mui/material';

interface PageContainerProps extends Omit<ContainerProps, 'sx'> {
  children: React.ReactNode;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  noPadding?: boolean;
}

/**
 * PageContainer - 统一的页面容器组件
 * 为所有页面提供一致的白色背景和内边距
 */
const PageContainer: React.FC<PageContainerProps> = ({
  children,
  maxWidth = 'lg',
  noPadding = false,
  ...rest
}) => {
  return (
    <Box
      sx={{
        width: '100%',
        minHeight: '100%',
        bgcolor: 'white',
        borderRadius: 3,
        boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
        overflow: 'hidden'
      }}
    >
      <Container
        maxWidth={maxWidth}
        sx={{
          py: noPadding ? 0 : 4,
          px: noPadding ? 0 : 3
        }}
        {...rest}
      >
        {children}
      </Container>
    </Box>
  );
};

export default PageContainer;

